import { render, staticRenderFns } from "./ChemCPP1220S4_Q10.vue?vue&type=template&id=04faa214&"
import script from "./ChemCPP1220S4_Q10.vue?vue&type=script&lang=ts&"
export * from "./ChemCPP1220S4_Q10.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VForm,VSelect})
